import React, { Fragment } from 'react';
import Reveal from './Reveal';

/**
 * Title-card headline: each word punches up out of its own mask, in
 * sequence, when the headline scrolls into view.
 *   *word*  -> red italic punch word (may span several words)
 *   ^word^  -> belt-gold italic word
 *   \n      -> line break
 */
export default function KineticHeadline({ text, as = 'h2', className = 'pnp-display pnp-h2', delay = 0, style }) {
  let i = 0;
  let accent = null; // null | 'red' | 'gold'
  const plain = text.replace(/[*^]/g, '').replace(/\n/g, ' ');
  const lines = text.split('\n');
  return (
    <Reveal as={as} rise={false} className={`pnp-kh ${className}`} delay={delay} style={style}>
      <span className="pnp-sr-only">{plain}</span>
      <span aria-hidden="true">
        {lines.map((line, li) => (
          <Fragment key={li}>
            {li > 0 ? <br /> : null}
            {line.split(' ').filter(Boolean).map((raw, wi, arr) => {
              if (raw.startsWith('*')) accent = 'red';
              if (raw.startsWith('^')) accent = 'gold';
              const kind = accent;
              if (raw.endsWith('*') || raw.endsWith('^')) accent = null;
              const word = raw.replace(/[*^]/g, '');
              const idx = i;
              i += 1;
              const cls = kind === 'red' ? 'pnp-kh-accent' : kind === 'gold' ? 'pnp-kh-gold' : undefined;
              return (
                <Fragment key={wi}>
                  <span className="pnp-kh-word">
                    <span className={cls} style={{ '--i': idx }}>{word}</span>
                  </span>
                  {wi < arr.length - 1 ? ' ' : null}
                </Fragment>
              );
            })}
          </Fragment>
        ))}
      </span>
    </Reveal>
  );
}
